export default theme => ({
  contacts: {
    marginBottom: 10,
  },
  toolLinkContainer: {
    paddingTop: 20,
    "& a": {
      color: theme.palette.link.dark,
    },
  },
  toolLinkIcon: {
    marginRight: 10,
  },
  privacy: {
    color: theme.palette.success.dark,
    border: `1px solid ${theme.palette.success.dark}`,
    margin: 10,
  },
  privacy__activated: {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
  },
  privacyButton: {
    display: "inline-block",
  },
});
